import { buildMatchableItemsCfn, matchesRequiredSku } from './build-matchable-items.cfn';
import { Notification } from '../../notifications/notification.class';
import { NotificationType } from '../../notifications/enums';
import { PromotionalSku } from '../promotional-sku.class';

export const validateCfn = (promotionalSku: PromotionalSku): void => {
	if (!promotionalSku.requiredSkus || promotionalSku.requiredSkus.length === 0) return;

	const { kitchen } = promotionalSku.refMap;
	if (!kitchen) return;

	const allItems = buildMatchableItemsCfn(kitchen);

	// OR logic: each requiredSku entry needs at least one matching item
	promotionalSku.requiredSkus.forEach((requiredSku) => {
		const hasMatch = allItems.some((item) => matchesRequiredSku(item, requiredSku));

		if (!hasMatch) {
			const duplicateNotification = promotionalSku.getNotications().find(
				(notification) => notification.validationCode === 'SKU_NOT_FOUND' && notification.refId === promotionalSku.id
			);

			if (!duplicateNotification) {
				promotionalSku.getNotications().push(new Notification({
					dataIn: {
						refId: promotionalSku.id,
						validationCode: 'SKU_NOT_FOUND',
						description: `Required SKU ${requiredSku} not found in kitchen`,
						type: NotificationType.Error
					}
				}));
			}
		}
	});

	if (!promotionalSku.allowMultiple) {
		const notifications = promotionalSku.getNotications();
		const count = notifications.filter((notification) => notification.refId === promotionalSku.id).length;
		if (count > 0) {
			const duplicateNotification = notifications.find(
				(notification) => notification.validationCode === 'DUPLICATE_SKU' && notification.refId === promotionalSku.id
			);

			if (!duplicateNotification) {
				promotionalSku.getNotications().push(new Notification({
					dataIn: {
						refId: promotionalSku.id,
						validationCode: 'DUPLICATE_SKU',
						description: 'Duplicate SKU found',
						type: NotificationType.Error
					}
				}));
			}
		}
	}
};
